const routes = [
    {
        path: "/coop/student/cv",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        }
    }
];

export default routes;
